import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import Pagination from "rc-pagination";

import Item from "./Item";
import { AdItem } from "src/components";

// data
import { ad_data } from "../../data";

// icons
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// helper
import { splitArrIntoNChunks } from "../../utils/helper";

import styles from "./MainSection.module.scss";

const cx = classNames.bind(styles);

const MainSection = ({ tabs, currentEvents, currentTab, handleTabChange }) => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [eventChunks, setEventChunks] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (currentEvents) {
      const chunks = splitArrIntoNChunks(currentEvents, 6);
      setEvents(chunks[0] || []);
      setEventChunks(chunks);
    }
  }, [currentEvents]);

  const handleChange = (value) => {
    setCurrentIndex(value);
    setEvents(eventChunks[value - 1]);
  };

  const tabChange = (_tab) => {
    handleTabChange(_tab);
    setCurrentIndex(1);
  };

  return (
    <div className={cx("main-section-root")}>
      <h2 className={cx("heading")}>You are searching by</h2>
      <div className={cx("tag-list")} layout>
        {tabs.map((tab) => (
          <span
            key={tab.index}
            className={cx({ active: tab?.index === currentTab?.index })}
            onClick={() => tabChange(tab)}
          >
            {tab.name}
          </span>
        ))}
      </div>
      <div className={cx("row")}>
        <div className={cx("list-section")}>
          {events.map((item, i) => (
            <Item key={i} data={item} />
          ))}
        </div>
        <div className={cx("advertisment-section")}>
          <AdItem data={ad_data} />
        </div>
      </div>
      <div className={cx("pagination")}>
        <Pagination
          onChange={handleChange}
          current={currentIndex}
          total={eventChunks.length * 10}
          prevIcon={
            <span className={cx("icon-wrapper")}>
              <FaChevronLeft size={12} />
            </span>
          }
          nextIcon={
            <span className={cx("icon-wrapper")}>
              <FaChevronRight size={12} />
            </span>
          }
        />
      </div>
    </div>
  );
};

export default MainSection;
